import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import ConstructionIcon from '@mui/icons-material/Construction';
import { useNavigate } from 'react-router-dom';

const WorkInProgress = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: '80vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        px: 2
      }}
    >
      <ConstructionIcon sx={{ fontSize: 80, color: '#FFA500', mb: 2 }} />
      <Typography variant="h4" gutterBottom>
        This Page is Under Construction
      </Typography>
      <Typography variant="body1" sx={{ maxWidth: '500px', mb: 3 }}>
        We're still working on this section of the site. It will be available soon.
        Stay tuned and thank you for your patience!
      </Typography>
      <Button variant="contained" onClick={() => {navigate('/');window.scrollTo(0, 0);}}>
        Back to Home
      </Button>
    </Box>
  );
};

export default WorkInProgress;
